module.exports = __webpack_public_path__ + "img/borderPolygonWhite.162974ce.svg";